"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Megaphone42Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "42px", height: "42px", viewBox: "0 0 42 42", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "megaphone-42", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M35,6 L35,36 L33,36 L33,34.467 L24,32.066 L24,34.3814992 C24,35.4860687 23.1045695,36.3814992 22,36.3814992 C21.822236,36.3814992 21.6452654,36.3577997 21.4737652,36.3110269 L14.4737652,34.401936 C13.6036427,34.1646298 13,33.3743104 13,32.4724083 L13,29.133 L7.9693494,27.7918265 C6.21833574,27.3248895 5,25.7390895 5,23.9268867 L5,18.0731133 C5,16.2609105 6.21833574,14.6751105 7.9693494,14.2081735 L33,7.533 L33,6 L35,6 Z M15,29.666 L15,32.4724083 L22,34.3814992 L22,31.533 L15,29.666 Z M33,9.60322329 L12,15.202 L12,26.797 L33,32.3967767 L33,9.60322329 Z M10,15.736 L8.4846747,16.1406434 C7.60916787,16.3741119 7,17.1670119 7,18.0731133 L7,23.9268867 C7,24.8329881 7.60916787,25.6258881 8.4846747,25.8593566 L10,26.263 L10,15.736 Z", id: "Combined-Shape", fill: "#000000", fillRule: "nonzero" })));
}
function Megaphone42(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Megaphone42Svg, Object.assign({}, svgProps)));
}
exports.default = Megaphone42;
//# sourceMappingURL=Megaphone42.js.map